<template>
  <div class="home-page">
    <page-head class="page-top"></page-head>
    <div class="page-content">
      <div class="right-content">
        <adjust-order style="padding: 0;"></adjust-order>
      </div>
    </div>
    <loading></loading>
  </div>
</template>

<script>
import store from '@/store'
import AdjustOrder from '@/view/oil/adjust_order'
import PageHead from '@/components/PageHeadAdjust'
import Loading from '@/components_bit/Loading'
export default {
  beforeRouteEnter (to, from, next) {
    if (store.getters.logined !== 1) {
      store.dispatch('setLoginFor', 'adjust_home')
      next({name: 'login'})
    } else if (!store.getters.oilArea) {
      next({name: 'index'})
    } else {
      next()
    }
  },
  components: {
    PageHead,
    AdjustOrder,
    Loading
  },
  created () {
    this.$store.dispatch('loadInputData')
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.page-top {
  z-index: 4;
}
.right-content::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// adjust_home.vue?31f84e36